import "./App.scss";
import "./transitions.scss";
import React from "react";
import Swipe from "react-easy-swipe";
import axios from "axios";
import FlashCard from "./Flashcard.jsx";
import { Button } from "@wwnds/react";
import { ReactComponent as NortonBirdIcon } from "./norton-logo.svg";
import confetti from "canvas-confetti";

import {
  Shuffle,
  Refresh,
  FlipCameraAndroid,
  ChevronLeft,
  ChevronRight,
} from "@material-ui/icons";

const BACKEND_URI = (
  process.env.REACT_APP_BACKEND_URI || '__RUNTIME_BACKEND_URI__'
).replace(/\/$/, '');
const prod = process.env.NODE_ENV === 'production';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shuffle: false,
      mode: false,
      flipped: false,
      index: 0,
      deleted: 0,
      loaded: false,
    };

    this.title = "";
    this.cards = [];
    this.cardCount = null;
  }
  componentDidMount() {
    this.fetchCards();
    if (!prod) console.log('cards:', this.cards);
  }
  componentDidUpdate(prevProps, prevState) {
    if (!this.cards.length && this.state.loaded && this.state.deleted !== 0)
      this.startConfetti();
  }

  startConfetti() {
    var duration = 3 * 1000;
    var animationEnd = Date.now() + duration;
    var defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

    function randomInRange(min, max) {
      return Math.random() * (max - min) + min;
    }

    var interval = setInterval(function () {
      var timeLeft = animationEnd - Date.now();

      if (timeLeft <= 0) {
        return clearInterval(interval);
      }

      var particleCount = 100 * (timeLeft / duration);
      // since particles fall down, start a bit higher than random
      confetti(
        Object.assign({}, defaults, {
          particleCount,
          origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
        })
      );
      confetti(
        Object.assign({}, defaults, {
          particleCount,
          origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
        })
      );
    }, 250);
  }

  render() {
    if (!prod) console.log('shuffle:', this.state.shuffle);
    let today = new Date();
    const DeckCompleted = this.state.deleted !== this.cardCount;

    return (
      <div className="App">
        <header className="App-header">
          <NortonBirdIcon className="app-icon hide-on-mobile " />
          <div style={{ fontSize: "14px" }}>
            <b>Flashcards</b>
          </div>
          <div style={{ fontSize: "12px" }}>{this.title}</div>{" "}
        </header>

        <Swipe
          onSwipeMove={this.onSwipeMove}
          onSwipeEnd={this.onSwipeEnd}
          className="card-container"
        >
          <div className="card-header">
            {DeckCompleted && (
              <>
                <div className="block">
                  <div style={{ fontSize: "14px" }}>
                    <b>Answer by</b>
                  </div>
                  <Button
                    className={
                      !this.state.mode
                        ? "term-definition-button selected"
                        : "term-definition-button"
                    }
                    onClick={() => {
                      this.setState({
                        mode: false,
                        flipped: false,
                        transition: "flip",
                      });
                    }}
                  >
                    Definition
                  </Button>
                  <Button
                    className={
                      this.state.mode
                        ? "term-definition-button selected"
                        : "term-definition-button"
                    }
                    onClick={() => {
                      this.setState({
                        mode: true,
                        flipped: false,
                        transition: "flip",
                      });
                    }}
                  >
                    <span>Term</span>
                  </Button>
                </div>

                <div className="block">
                  <Button
                    icon="shuffle"
                    className="misc-button"
                    onClick={() => {
                      this.shuffleCards();
                    }}
                  >
                    <Shuffle style={{ width: "18px", height: "18px" }} />
                    <span className="hide-on-mobile">&nbsp;&nbsp;Shuffle</span>
                  </Button>
                  <Button
                    icon="replay"
                    className="misc-button"
                    style={{ marginLeft: "10px" }}
                    onClick={() => {
                      this.reloadCards();
                    }}
                  >
                    <Refresh style={{ width: "18px", height: "18px" }} />
                    <span className="hide-on-mobile">
                      &nbsp;&nbsp;Start Over
                    </span>
                  </Button>
                </div>
              </>
            )}
          </div>

          <div
            className={DeckCompleted ? "card-block" : "card-block flex-center"}
          >
            {this.cards.length !== 0 && (
              <React.Fragment>
                <div style={{ height: "30px" }}>
                  <Button
                    style={{ float: "right" }}
                    className="hide-card-button"
                    onClick={() => {
                      this.deleteTopCard();
                    }}
                  >
                    <span
                      className="material-icons"
                      style={{ fontSize: "12px" }}
                    >
                      hide_source
                    </span>
                    <span>&nbsp; Hide Card</span>
                  </Button>
                </div>
                {this.state.loaded && DeckCompleted && (
                  <FlashCard
                    key={this.state.index}
                    term={this.cards[this.state.index].term}
                    definition={this.cards[this.state.index].definition}
                    flipped={this.state.flipped}
                    mode={this.state.mode}
                    transition={this.state.transition}
                    input=""
                  />
                )}
              </React.Fragment>
            )}
            {!this.cards.length && this.state.loaded && (
              <div
                className="card"
                style={{ textAlign: "center", color: "var(--nds-navy-100)" }}
              >
                <p style={{ fontSize: "56px", marginBottom: "48px" }}>
                  Congratulations
                </p>
                <p style={{ fontSize: "20px" }}>
                  You finished reviewing all the cards.
                </p>

                <Button
                  icon="replay"
                  className="misc-button"
                  onClick={() => {
                    this.reloadCards();
                  }}
                >
                  <Refresh />
                  <span className="hide-on-mobile">&nbsp;&nbsp;Start Over</span>
                </Button>
              </div>
            )}

            {DeckCompleted && (
              <Button
                className="flip-card-button"
                onClick={() => {
                  this.flipCard();
                }}
              >
                <FlipCameraAndroid style={{ width: "24px", height: "24px" }} />
                &nbsp;Flip Card
              </Button>
            )}
          </div>

          <nav className="button-toolbar">
            {DeckCompleted && (
              <>
                <Button
                  className="nav-button"
                  onClick={this.previousCard}
                  style={{ borderRadius: "30px" }}
                >
                  <ChevronLeft style={{ fontSize: "1.75em" }} />
                </Button>
                <div
                  role="status"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <span
                    style={{
                      padding: "0px 10px",
                      fontSize: "18px",
                      color: "var(--nds-navy-100)",
                    }}
                  >
                    Card <b>{this.state.index + 1}</b> of {this.cards.length}
                  </span>
                  {this.state.deleted !== 0 && (
                    <span>({this.state.deleted} hidden)</span>
                  )}
                  <p className="sr-only">
                    {this.state.flipped
                      ? "Flipped to back"
                      : "Flipped to front"}
                  </p>
                </div>
                <Button
                  className="nav-button"
                  onClick={this.nextCard}
                  style={{ borderRadius: "30px" }}
                >
                  <ChevronRight style={{ fontSize: "1.75em" }} />
                </Button>
              </>
            )}
          </nav>
        </Swipe>
        <footer>© {today.getFullYear()} W. W. Norton and Company, Inc.</footer>
      </div>
    );
  }

  fetchCards = async () => {
    const params = new URLSearchParams(document.location.search);
    if (params.size <= 0) return;

    // Deck title from ?t=. Links wrap it in a delimiter (quote or X), so strip
    // the first/last char when they match.
    const rawTitle = params.get('t') || '';
    this.title =
      rawTitle.length > 1 && rawTitle[0] === rawTitle[rawTitle.length - 1]
        ? rawTitle.slice(1, -1)
        : rawTitle;

    const routeMap = new Map([
      ['book', params.get('s')],
      ['chapterId', params.get('c')],
      ['letterId', params.get('l')],
      ['collectionId', params.get('g')],
    ]);

    const route = [...routeMap].filter(([r, v]) => v).reduce((a, [r, v]) => `${a}/${r}/${v}`, '')

    if (!prod) console.log('route:', { route, routeMap });

    if (!route) return;

    try {
      const response = await axios.get(BACKEND_URI + route)
      if (!prod) console.log('response:', response);
      this.cards = response.data;
      this.cardCount = this.cards.length;
      this.setState({ loaded: true });
    } catch (err) {
      console.error(err);
    }
  };

  onSwipeMove = (position, event) => {
    if (position.x < -75) {
      if (!prod) console.log(`Moved ${position.x} pixels horizontally`, event);

      this.setState({ direction: "left" });
    } else if (position.x > 75) {
      if (!prod) console.log(`Moved ${position.x} pixels horizontally`, event);

      this.setState({ direction: "right" });
    }

    return true;
  };

  onSwipeEnd = (event) => {
    if (!prod) console.log(this.state.direction);
    if (this.state.direction === "left") {
      this.nextCard();
    } else if (this.state.direction === "right") {
      this.previousCard();
    }
    this.setState({ direction: "" });
  };

  shuffle = (a) => {
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  };

  previousCard = () => {
    let new_index =
      this.state.index - 1 === -1
        ? this.cards.length - 1
        : this.state.index - 1;

    this.setState({
      index: new_index,
      flipped: false,
      transition: "prev",
    });
  };

  nextCard = () => {
    this.setState({
      index: (this.state.index + 1) % this.cards.length,
      flipped: false,
      transition: "next",
    });
  };

  flipCard = () => {
    this.setState({ flipped: !this.state.flipped, transition: "flip" });
  };

  shuffleCards = () => {
    this.cards = this.shuffle(this.cards);
    this.setState({
      shuffle: !this.state.shuffle,
      flipped: false,
      index: 0,
      transition: "fade",
    });
  };

  reloadCards = () => {
    // window.location.reload();
    this.fetchCards();
    this.setState({ deleted: 0, index: 0, transition: "fade", mode: false });
  };

  deleteTopCard = () => {
    if (this.cards.length > 0) {
      this.cards.splice(this.state.index, 1);
      this.setState({
        shuffle: !this.state.shuffle,
        flipped: false,
        deleted: this.state.deleted + 1,
        transition: "delete",
      });
      if (this.cards.length < this.state.index + 1)
        this.setState({ index: this.state.index - 1 });
    }
  };
}

export default App;
